import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Hero from '../components/home/Hero';
import Services from '../components/home/Services';
import ShopPromo from '../components/home/ShopPromo';
import Portfolio from '../components/home/Portfolio';
import ContactStrip from '../components/home/ContactStrip';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      <Hero />
      <Services />
      <ShopPromo />
      <Portfolio />
      <ContactStrip />
      <Footer />
    </div>
  );
};

export default HomePage;
